// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { firebase, firebaseui } from 'firebaseui-angular';
export const environment = {
  production: false,
  stripeKey: 'pk_test_51H8B2rHj21akkiN8Hi9C29Da31eWbIK7LnAh9peuKYOdl8oXgFuNo2EpQin8T1Nv0qr2mEZOyGYPPoL2zIZtfhIW00FtgUpdWa',
  firebase: {
    apiKey: 'AIzaSyBdIm6DL7IrKEw3jnPHNKS5mqElTt93Reg',
    authDomain: 'insider-trading-alerts.firebaseapp.com',
    databaseURL: 'https://insider-trading-alerts.firebaseio.com',
    projectId: 'insider-trading-alerts',
    storageBucket: 'insider-trading-alerts.appspot.com',
    messagingSenderId: '195225381125',
    appId: '1:195225381125:web:15d0fda4b8c71b7a9c2f6c',
    measurementId: 'G-WYNX2QVWNX'
  },
  firebaseUiAuthConfig: {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      {
        scopes: [
          'public_profile',
          'email',
          'user_likes',
          'user_friends'
        ],
        customParameters: {
          'auth_type': 'reauthenticate'
        },
        provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID
      },
      firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      firebase.auth.GithubAuthProvider.PROVIDER_ID,
      {
        requireDisplayName: false,
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID
      },
      firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
    ],
    tosUrl: 'https://insider-trading-alerts.web.app/privacy',
    privacyPolicyUrl: 'https://insider-trading-alerts.web.app/privacy',
    credentialHelper: firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM
  },
  proxy_herokuapp: 'https://cors-anywhere.herokuapp.com/',
  proxy_all_origins: 'https://api.allorigins.win/raw?url=',
  proxy_local: 'http://localhost:8010/proxy/',
  cors_mode: 'cors'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
